/** Marks a server-rendered control as a lightbox trigger; the value is the slide index. */
export const LIGHTBOX_INDEX_ATTR = 'data-lightbox-index';
